var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRepeatinline = function SvgRepeatinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.744.06a.42.42 0 0 0-.453.088l-2.534 2.509A9.89 9.89 0 0 0 9.993 0a9.99 9.99 0 0 0-8.5 4.743 10.005 10.005 0 0 0 2.87 13.519A9.99 9.99 0 0 0 17.988 16a1.668 1.668 0 0 0-1.568-2.65 1.67 1.67 0 0 0-1.097.65 6.66 6.66 0 0 1-5.928 2.64 6.66 6.66 0 0 1-5.36-3.659 6.67 6.67 0 0 1 2.714-8.804 6.66 6.66 0 0 1 3.244-.844A6.58 6.58 0 0 1 14.383 5l-2.822 2.802a.42.42 0 0 0 .033.62q.095.075.215.088l7.728.857h.047A.413.413 0 0 0 20 8.95V.445a.42.42 0 0 0-.256-.385"
  })));
};
export default SvgRepeatinline;